import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';

import TablePageLayout from '../../../layouts/TablePageLayout';
import Table from '../../Table';

import BorrowerService from '../../../services/BorrowerService';
import { useUiStore } from '../../../store';

const cols = [
  {
    title: 'Name',
    key: 'id',
    format: (value, row) => `${row.firstName} ${row.lastName}`,
  },
  {
    title: 'Coborrower',
    key: 'isCoborrower',
    format: (value) => (value ? 'Yes' : 'No'),
  },
];

export default function Borrowers({ isAddBorrowerFormVisible, isEdit }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const showDialogModal = useUiStore((state) => state.showDialogModal);
  const notify = useUiStore((state) => state.notify);

  const { data: borrowers, refetch } = useQuery({
    queryKey: ['borrowers', id],
    queryFn: () => BorrowerService.getBorrowersOfLoanFile(id),
    enabled: !!id,
  });

  // console.log(borrowers);

  const { mutate: deleteBorrower } = useMutation({
    mutationFn: (borrowerId) => BorrowerService.deleteBorrower(borrowerId),
    onSuccess: async () => {
      console.log('Borrower deleted successfully');
      refetch();
      notify({ type: 'success', message: 'Borrower deleted successfully' });
    },
    onError: (error) => {
      console.log(error);
      notify({ type: 'error', message: 'Error deleting borrower' });
    },
  });

  const actions = [
    {
      title: 'Edit',
      onClick: (row) =>
        navigate(`/loan-files/${row.loanFileId}/borrowers/${row.id}`),
      icon: 'edit',
    },
    {
      title: 'Delete',
      onClick: (row) =>
        showDialogModal({
          title: 'Delete Borrower',
          text: `Are you sure you want to delete this borrower?`,
          onConfirm: () => deleteBorrower(row.id),
        }),
      icon: 'delete',
      danger: true,
    },
  ];

  return (
    <TablePageLayout title={isEdit ? 'Edit Loan File' : 'Add Loan File'}>
      <div className="flex flex-col gap-15">
        {borrowers?.length || isAddBorrowerFormVisible ? (
          <Table
            rows={borrowers}
            cols={cols}
            actions={actions}
            createButtonLabel="Add Borrower"
            onCreateButtonClick={() =>
              navigate(`/loan-files/${id}/borrowers/new`)
            }
          />
        ) : (
          <p
            className={`text-gray-500 text-center text-lg mt-1 md:mt-5 ${isAddBorrowerFormVisible ? 'hidden' : ''}`}
          >
            There are no borrowers for this loan file. Click the button above to
            add a borrower
          </p>
        )}
      </div>
    </TablePageLayout>
  );
}
